/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Listen_FirstInputs */

const en_playbar_listen_first = /** @type {(inputs: Playbar_Listen_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to your first document`)
};

const es_playbar_listen_first = /** @type {(inputs: Playbar_Listen_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha tu primer documento`)
};

/**
* | output |
* | --- |
* | "Listen to your first document" |
*
* @param {Playbar_Listen_FirstInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_listen_first = /** @type {((inputs?: Playbar_Listen_FirstInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Listen_FirstInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_listen_first(inputs)
	return en_playbar_listen_first(inputs)
});